<template>
  <v-col cols="12">
    <div>
      <naj-box
        :no-header="hideNajBox"
        :no-gutters="hideNajBox"
        :no-margin-bottom="hideNajBox"
        :title="locales.sectionTitle"
      >
        <v-row align="start">
          <v-col cols="4">
            <naj-input
              :type-id="formFieldType.text"
              :label="locales.reportNumber"
              :value.sync="reportNumberValue"
              :disabled="isChecking || viewMode"
              :validates="required ? 'required' : ''"
              :error-messages="inputError ? [inputError] : []"
              @input="reportNumberChanged"
            ></naj-input>
            <input
              v-show="false"
              v-validate="required ? 'required' : ''"
              v-model="verifiedValue"
              :name="hiddenFieldName"
              :data-vv-as="locales.reportNumber"
            />
            <naj-error-text
              v-if="serverError"
              :text="serverError"
              size="small"
            />
            <naj-error-text
              v-else-if="errors.has(hiddenFieldName)"
              :text="errors.first(hiddenFieldName)"
              size="small"
            />
            <p
              v-else-if="isVerified"
              class="v-messages success--text mt-1 mb-0"
            >
              {{ local.common.verificationSucceeded }}
            </p>
          </v-col>
          <v-col
            v-if="showVerifyButton"
            cols="4"
            align-self="center"
          >
            <naj-button
              square
              :loading="isChecking"
              :disabled="isCheckButtonDisabled || viewMode"
              @click="check"
            >
              {{ local.personInformation.check }}
            </naj-button>
          </v-col>
        </v-row>
      </naj-box>
    </div>
  </v-col>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapGlobalActions } = createNamespacedHelpers('GlobalModule');

export default {
  name: 'ReportNumberInput',

  inject: ['$validator'],

  props: {
    formModel: {
      type: Object,
      required: true,
    },
    rootFormModel: {
      type: Object,
      required: false,
    },
    hideNajBox: {
      type: Boolean,
      required: false,
    },
    viewMode: {
      type: Boolean,
      required: false,
    },
    required: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      isChecking: false,
      reportNumberValue: this.formModel.reportNumberValidationTextBox || '',
      showVerifyButton: true,
      verifiedValue: '',
      serverError: '',
      hiddenFieldName: `reportNumberVerified_${Math.random().toString(36).slice(2)}`,
      isDirty: false,
    };
  },

  computed: {
    locales() {
      return this.local.dynamicFormAdmin.customComponents.reportNumberInput;
    },
    isVerified() {
      return this.verifiedValue === 'verified';
    },
    isValueTooShort() {
      const trimmed = (this.reportNumberValue || '').trim();
      return !trimmed || trimmed.length <= 3;
    },
    isCheckButtonDisabled() {
      return !this.reportNumberValue || this.isChecking || this.isValueTooShort;
    },
    inputError() {
      if (!this.isDirty) return '';
      return this.isValueTooShort ? this.locales.invalidInput : '';
    },
  },

  watch: {
    reportNumberValue(val) {
      this.$set(this.formModel, 'reportNumberValidationTextBox', val);
    },
    'formModel.reportNumberValidationTextBox'(newVal) {
      if (newVal !== this.reportNumberValue) {
        this.reportNumberValue = newVal || '';
      }
    },
  },

  created() {
    if (this.formModel.isReportNumberVerified && this.reportNumberValue) {
      this.verifiedValue = 'verified';
      this.showVerifyButton = false;
    }
  },

  methods: {
    ...mapGlobalActions(['validateReportNumber']),
    reportNumberChanged() {
      this.isDirty = true;
      this.verifiedValue = '';
      this.serverError = '';
      this.showVerifyButton = true;
      this.$set(this.formModel, 'isReportNumberVerified', false);
      this.$store.dispatch('LawsuitModule/updateCaseRelatedCaseCodeByReportNumber', null);
      this.$nextTick(() => {
        this.$validator.validate(this.hiddenFieldName);
      });
    },
    check() {
      this.isChecking = true;
      this.serverError = '';
      this.validateReportNumber(this.reportNumberValue)
        .then((response) => {
          const data = response?.data || {};
          // Extract relatedCaseCode when isLinked is true, otherwise null
          const relatedCaseCode = data.isLinked ? data.relatedCaseCode : null;
          this.onVerifySuccess(relatedCaseCode);
        })
        .catch((error) => {
          const errorData = error?.response?.data;
          this.serverError = errorData?.detail
            || (typeof errorData === 'string' && errorData)
            || this.locales.verifyError;
          this.verifiedValue = '';
        })
        .finally(() => {
          this.isChecking = false;
        });
    },
    onVerifySuccess(relatedCaseCode) {
      this.verifiedValue = 'verified';
      this.showVerifyButton = false;
      this.serverError = '';
      this.$set(this.formModel, 'isReportNumberVerified', true);
      this.$store.dispatch('LawsuitModule/updateCaseRelatedCaseCodeByReportNumber', relatedCaseCode);
      this.$validator.errors.remove(this.hiddenFieldName);
      this.toaster.success(this.local.common.verificationSucceeded);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
